import { get, post, del } from "../../axios";
import { generateQueryParams } from "./api-contracts";
import { responseIsSuccessful } from "../../global-helpers";
import {
  formatObjectWithNotes,
  makeFormData,
  simpleResponse
} from "../api-helpers";
import { WorkOrder } from "../../models/WorkOrder";
import { formatContactObject } from "../api-contacts";

export async function getContractWorkOrders(contractId) {
  const queryParams = generateQueryParams(contractId);
  return await get(`work-orders/${queryParams}`, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.work_orders) {
        return res.data.work_orders.map(wo => {
          formatContactObject(wo.contact);
          formatObjectWithNotes(wo);
          return new WorkOrder(wo);
        });
      }
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function storeWorkOrder(workOrder) {
  const formData = makeFormData({ work_order_params: workOrder });
  return await simpleResponse(
    post("work-orders", formData, window.localStorage.apiToken)
  );
}

export async function updateWorkOrder(workOrder) {
  const formData = makeFormData({
    work_order_params: workOrder,
    _method: "put"
  });
  return await simpleResponse(
    post(`work-orders/${workOrder.id}`, formData, window.localStorage.apiToken)
  );
}

export async function deleteWorkOrder(workOrder) {
  return await simpleResponse(
    del(`work-orders/${workOrder.id}`, window.localStorage.apiToken)
  );
}
